// extracted by mini-css-extract-plugin
var _1 = "EditVerificationModal-module__animateUploadProgressBarWidth--nntSL";
var _2 = "EditVerificationModal-module__animatedBackground--sbW9R";
var _3 = "EditVerificationModal-module__error--WoPRs";
var _4 = "EditVerificationModal-module__errorIcon--Styoo";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "error", _4 as "errorIcon" }
